module.exports = __webpack_public_path__ + "03_short_gold.eeb50761.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_short_gold.png
// module id = H4vX
// module chunks = 0